"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DropdownItem_1 = __importDefault(require("../../atoms/inputs/DropdownItem"));
const DropdownContainer_1 = __importDefault(require("../../atoms/inputs/DropdownContainer"));
function Dropdown({ items, button }) {
    return (react_1.default.createElement(DropdownContainer_1.default, { triggerElement: button, className: "-mt-2 mr-4 w-48" },
        react_1.default.createElement("div", { className: "ring-black dark:bg-black-800 bg-white border dark:border-gray-700 border-white rounded-md ring-opacity-5 ring-1", role: "menu", "aria-orientation": "vertical", "aria-labelledby": "options-menu" }, items === null || items === void 0 ? void 0 : items.map(({ title, disabled, onClick, icon }, index) => {
            return (react_1.default.createElement(DropdownItem_1.default, { key: `dropdown_${index}`, title: title, disabled: disabled, icon: icon, onClick: () => {
                    if (onClick)
                        onClick();
                } }));
        }))));
}
exports.default = Dropdown;
